import React from "react";

import { CellContext } from "@tanstack/react-table";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import type { LibreViewClinicPatient } from "@/models/LibreViewModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { ColumnHeader } from "@/uiKit/organisms/PatientSync/columnHeader.tsx";
import { DateUtils } from "@/utils/dateUtils.ts";

export const LastDataSinceCell: React.FC<CellContext<LibreViewClinicPatient, string | undefined>> = ({ getValue }) => {
  const value = getValue();
  const { t } = useTranslation();

  if (value === undefined) {
    return <Typography variant="body">{""}</Typography>;
  }

  const hours = DateTime.now().diff(DateTime.fromISO(value), "hours").hours;
  if (hours < 24) {
    return <Typography variant="body">{t("patientSync.libreviewTable.lessThanADay")}</Typography>;
  }

  return (
    <Typography variant="body">
      {DateUtils.humanDurationFromNow(value, { limit: "day", addNextUnit: false })}
    </Typography>
  );
};

export const LastDataSinceHeader: React.FC = () => (
  <ColumnHeader translationKey="patientSync.libreviewTable.lastDataSince" />
);
